import ZkEmailAndPhone from './src/main'
ZkEmailAndPhone.install = function (Vue) {
  Vue.component(ZkEmailAndPhone.name, ZkEmailAndPhone)
}
export default ZkEmailAndPhone



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/emailAndPhone/index.js